<div class="modal-header" [ngClass]="{ 'justify-content-center': headerCentered }">
  <ng-content select=".modal-title"></ng-content>
  <rx-button *ngIf="showCloseButton" buttonClass="subtle-circle" (click)="closeModal.emit('Cross click')">
    <i class="rx-close"></i>
  </rx-button>
</div>
<ng-content select=".modal-body"></ng-content>
<ng-content select=".modal-footer"></ng-content>
